/** This was exported from the Toolbar in Tandem, but LMV doesn't have it. */
export function shiftControls(right, top) {
    const toolbarSelector = '.adsk-viewing-viewer .adsk-toolbar.adsk-toolbar-vertical';
    const cubeSelector = '.viewcubeWrapper';
    const statusBarSelector = '.adsk-viewing-viewer .status-line';

    for (const element of document.querySelectorAll(toolbarSelector)) {
        applyTranslate(element, { right, top });
    }

    for (const element of document.querySelectorAll(cubeSelector)) {
        applyTranslate(element, { right, top });
    }

    for (const element of document.querySelectorAll(statusBarSelector)) {
        applyTranslate(element, { right, top });
    }

    const bimWalkInfoButton = document.querySelector('#tooltip-info');
    if (bimWalkInfoButton) {
        applyTranslate(bimWalkInfoButton, { right, top });
    }
}

/** Shifts 2D Plan mode level label list horizontally to clear the left side panel. */
export function shiftPlanModeLevelLabels(left) {
    const planListSelector = '.adsk-viewing-viewer .hud-level-plan-list';
    for (const element of document.querySelectorAll(planListSelector)) {
        applyTranslate(element, { left });
    }
}

/** Persisted shift offsets on the element. */
function ensureTranslateDataset(element) {
    if (element.dataset.left === undefined) element.dataset.left = 0;
    if (element.dataset.right === undefined) element.dataset.right = 0;
    if (element.dataset.top === undefined) element.dataset.top = 0;
}

/** Applies dataset offsets as a single CSS translate: (left - right, top). */
function applyTranslate(element, { left, right, top } = {}) {
    ensureTranslateDataset(element);

    if (left !== undefined) element.dataset.left = left || 0;
    if (right !== undefined) element.dataset.right = right || 0;
    if (top !== undefined) element.dataset.top = top || 0;

    const x = Number(element.dataset.left) - Number(element.dataset.right);
    const y = Number(element.dataset.top);

    element.style.translate = `${x}px ${y}px`;
}
